import angular = require('angular');
import { CurrentUserService } from 'services/currentUser';
import { FlagshipService } from 'services/flagship';

const getPagePath = (flag: FeatureFlag): string => {
    switch (flag) {
        case 'ReactClaimsPage':
            return 'claims';
        case 'ReactChecklistPage':
            return 'checklist';
        case 'ReactCoveragePage':
            return 'coverage';
        case 'ReactGetMorePage':
            return 'get-more';
        case 'ReactOverviewPage':
            return 'overview';
        case 'DocumentsReactPage':
            return 'documents';
    }
    return '';
};

export const checkFeatureFlagAndRedirect = (
    flag: FeatureFlag,
    flagshipService: FlagshipService,
    $window: angular.IWindowService,
    currentUserService?: CurrentUserService,
    policyIndex?: RoutePolicyIndex
): void => {
    if (flagshipService.getFlag(flag)) {
        if (policyIndex === undefined) {
            if (flag === 'ReactPolicyList') {
                $window.location.replace(`${window.appConfig.REACT_HOST}/policies`);
            }
            if (flag === 'ReactLoginPage') {
                $window.location.replace(`${window.appConfig.REACT_HOST}/login`);
            }
            return;
        }
        if (currentUserService) {
            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policy) => {
                if (policy) {
                    let redirectUri = window.appConfig.REACT_HOST;
                    if (flag === 'ReactPolicyList') {
                        return;
                    } else {
                        redirectUri += `/policy/${policy.policy_uuid}/${getPagePath(flag)}`;
                    }
                    $window.location.replace(redirectUri);
                }
            });
        }
    }
};
